module.exports = __webpack_public_path__ + "img/xcl_unilateral.99b693d.png";